// Module
var code = `<template class="baloon">
  <require from="./baloon.scss"></require>
  <slot></slot>
  <span if.bind="value" class="baloon__value">\${value}</span>
</template>
`;
// Exports
export default code;